<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Speeds" button-url="pmtaSpeedCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <div class="form-group">
                                <small class="form-text text-muted mt-0">
                                    In read mode(local value = 0) only "VMTA max-smtp-msg-rate" is read.<br />
                                    In write mode(local value !=0) "VMTA max-smtp-msg-rate" and "domain * max-msg-rate" are overwritten.<br /><br />
                                    Synchronization occurs automatically every 30 minutes, or by pressing button 'Sync'.<br /><br />
                                    Meaning of status colors: <br />
                                    <i style="font-size: 0.75em;color:#ffe533;" class="fas fa-circle"></i> - NOT synchronized.<br />
                                    <i style="font-size: 0.75em;color:#2fff00;" class="fas fa-circle"></i> - synchronized.
                                </small>
                            </div>
                            <button type="button" class="btn btn-info btn-rounded mr-2 mb-2" @click="bulkSync()"
                                v-bind:disabled="!selectedSpeeds.length">
                                <i class="far fa-sync"></i>
                                Sync with relays
                            </button>
                            <button type="button" class="btn btn-danger btn-rounded mr-2 mb-2" @click="bulkDelete()"
                                v-bind:disabled="!selectedSpeeds.length">
                                <i class="far fa-trash-alt"></i>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group">
                                <treeselect placeholder="Search by Pmta Relay Group" v-model="filter.pmtaRelayGroup.id"
                                    :multiple="true" :options="pmtaRelayGroupList"
                                    :load-options="loadPmtaRelayGroupList" />
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by Mail Provider" v-model="filter.provider.id"
                                    :multiple="true" :options="providerList" :load-options="loadProviderList" />
                            </div>
                            <div class="input-group form-group">
                                <input v-model="filter.localValue" type="text" class="form-control form-control-line"
                                    placeholder="Search by Local value">
                            </div>
                        </div>
                    </div>
                    <div class="form-inline col-12">
                        <div class="form-group col-2 mb-2">
                            <span>Total:
                                <span class="label label-info">{{ totalItems }}</span>
                            </span>
                        </div>
                        <div class="form-group col-2 mb-2 ml-auto mr-3">
                            <button class="btn btn-info text-uppercase waves-effect waves-light w-100" @click="search">
                                Search
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{ preloader: loading }"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="speedList.length > 0">
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th><input type="checkbox" v-model="selectAllSpeeds"
                                                            @click="selectAll()">
                                                    </th>
                                                    <th @click="tableOrdering('pmtaRelay.smtpHost')">
                                                        <span role='button'>Relay</span>
                                                    </th>
                                                    <th @click="tableOrdering('provider.name')">
                                                        <span role='button'>Provider</span>
                                                    </th>
                                                    <th @click="tableOrdering('localValue')">
                                                        <span role='button'>Local value</span>
                                                    </th>
                                                    <th @click="tableOrdering('remoteValue')">
                                                        <span role='button'>Remote value</span>
                                                    </th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(speed, index) in speedList" :key="index">
                                                    <td class="align-middle">
                                                        <input type="checkbox" v-model="selectedSpeeds"
                                                            :value="speed.id">
                                                    </td>
                                                    <td class="align-middle">
                                                        {{ speed.pmtaRelay.smtpHost }}
                                                    </td>
                                                    <td class="align-middle">{{ speed.provider.name }}</td>
                                                    <td class="align-middle">{{ speed.localValue }}</td>
                                                    <td class="align-middle">{{ speed.remoteValue }}</td>
                                                    <td>
                                                        <i style="font-size: 0.75em;"
                                                            v-bind:style="{ 'color': getStatusColor(speed.localTime, speed.remoteTime) }"
                                                            class="fas fa-circle"></i>
                                                    </td>
                                                    <td class="align-middle">
                                                        <button type="button" class="btn btn-sm btn-info m-r-10"
                                                            @click="syncSpeed([speed.id])">
                                                            <i class="fas fa-sync"></i> Sync
                                                        </button>
                                                        <router-link
                                                            :to="{ name: 'pmtaSpeedEdit', params: { id: speed.id } }"
                                                            class="btn btn-info btn-sm">
                                                            <i class="fa fa-edit"></i> Edit
                                                        </router-link>
                                                        <button type="button" class="btn btn-sm btn-danger m-l-10"
                                                            @click="deleteSpeed([speed.id])">
                                                            <i class="fa fa-minus-circle"></i> Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <paginate v-if="pageCount > 1" v-model="page" :page-count="pageCount" :page-range="3"
                                :margin-pages="2" :click-handler="getItems" :prev-text="'Prev'" :next-text="'Next'"
                                :container-class="'pagination justify-content-center'" :page-class="'page-item'"
                                :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'"
                                :next-class="'page-item'" :next-link-class="'page-link'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Swal from 'sweetalert2';
import PmtaSpeedService from '../services/PmtaSpeedService';
import Preloader from '../components/Preloader';
import Breadcrumb from '../components/Breadcrumb';
import Treeselect from '@riophae/vue-treeselect';
import paginateMixin from '../mixins/paginate-mixin';
import RelayGroupService from '../services/PmtaRelayGroupService';
import MailProviderService from '../services/MailProviderService';

export default {
    name: 'PmtaSpeeds',
    components: {
        Preloader, Breadcrumb, Treeselect
    },
    data() {
        return {
            isAdmin: this.$store.getters.isAdmin,
            speedList: [],
            filter: {
                pmtaRelayGroup: { id: null },
                provider: { id: null },
                localValue: null
            },
            order: {
                field: "pmtaRelay.id",
                asc: true
            },
            selectedSpeeds: [],
            selectAllSpeeds: false,
            pmtaRelayGroupList: null,
            providerList: null,
            loading: false,
            totalItems: 0,
            page: 1,
            perPage: paginateMixin.defaultPerPage,
        }
    },
    mounted() {
        this.getItems(this.page = 1);
    },
    methods: {
        getStatusColor(localTime, remoteTime) {
            if (remoteTime === null) {
                return '#ffe533';
            }
            return this.moment(localTime).isBefore(remoteTime) ? '#2fff00' : '#ffe533';
        },
        loadProviderList({ callback }) {
            MailProviderService.getProviderSelect().then(response => {
                this.providerList = response.data['hydra:member'].map(provider => {
                    return { id: provider.id, label: provider.name }
                });
                callback();
            });
        },
        loadPmtaRelayGroupList({ callback }) {
            RelayGroupService.getGroupSelect().then(response => {
                this.pmtaRelayGroupList = response.data['hydra:member'].map(group => {
                    return { id: group.id, label: group.name }
                });
                callback();
            });
        },
        getItems: function () {
            this.loading = true;
            PmtaSpeedService.getPmtaSpeeds(
                this.page,
                this.perPage,
                this.filter,
                this.order
            ).then(response => {
                this.speedList = response.data['hydra:member'];
                this.totalItems = response.data['hydra:totalItems'];
                this.loading = false;
            });
        },
        search: function () {
            this.getItems();
        },
        tableOrdering(field) {
            if (this.order.field === field) {
                this.order.asc = (this.order.asc === true) ? false : true;
            } else {
                this.order.field = field;
                this.order.asc = true;
            }
            this.getItems();
        },
        deleteSpeed(ids) {
            Swal({
                title: 'Are you sure you want to delete?',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaSpeedService.deletePmtaSpeed(ids).then((response) => {
                        if (response.status === 204) {
                            this.getItems();
                        } else {
                            Swal.showValidationMessage(
                                `Delete failed: ${response.data.error}`
                            );
                            return false;
                        }
                    }).catch(error => {
                        Swal.showValidationMessage(
                            'Error: ' + error.response.data.error[0]
                        )
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value) {
                    Swal(
                        'Deleted successfully!',
                        `Speed has been deleted.`,
                        'success'
                    )
                }
            })
        },
        bulkDelete() {
            this.deleteSpeed(this.selectedSpeeds);
            this.selectedSpeeds = []
        },
        syncSpeed(ids) {
            Swal({
                title: 'Dont use this for more than 3 speeds! -Just wait for the automatic update (about 30 minutes).',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Synchronize!',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaSpeedService.syncPmtaSpeed(ids).then((response) => {
                        if (response.status === 200) {
                            this.getItems();
                        } else {
                            Swal.showValidationMessage(
                                `Sync failed: ${response.data.error}`
                            );
                            return false;
                        }
                    }).catch(error => {
                        Swal.showValidationMessage(
                            'Error: ' + error.response.data.error[0]
                        )
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value) {
                    Swal(
                        'Sync successfully!',
                        `The remote value(s) has been synchronized.`,
                        'success'
                    )
                }
            })
        },
        bulkSync() {
            this.syncSpeed(this.selectedSpeeds);
            this.selectedSpeeds = []
        },
        selectAll() {
            this.selectedSpeeds = [];
            if (!this.selectAllSpeeds) {
                for (let speed of this.speedList) {
                    this.selectedSpeeds.push(speed.id);
                }
            }
        },

    },
    computed: {
        pageCount: function () {
            return Math.ceil(this.totalItems / this.perPage);
        }
    }
}
</script>

<style scoped></style>